import { 
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT, 
    SAGE_HAT,
    TURTLE_RESCUE_CLUB_T_SHIRT,  
    Product
} from '../products';

const turtlRescueClubPinRecos: Product[] = [
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    SAGE_HAT,
    TURTLE_RESCUE_CLUB_T_SHIRT,   
];

export default turtlRescueClubPinRecos;